import { updatePool } from '@/api/asset/pool/update';
import Loading from '@/component/mui/Backdrop';
import { PoolSettingForm } from '@/component/pool-setting/Form';
import { compareObjects } from '@/lib/Compare';
import { PoolType } from '@/types';
import { Box, Button } from '@mui/material';
import { useEffect, useState, MouseEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function PoolDetail() {
  const {
    state: { rowValue },
  } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const [pools, setPools] = useState<PoolType>({
    symbol: 'SFL',
    title: '',
    description: '',
    address: '',
    contractAddr: '',
    period_sec: '0',
    periodMonth: '0',
    bonusPercent: '0',
    interestRate: '0',
    minUsdt: '0',
    maxUsdt: '0',
    goalUsdt: '0',
    goalMaxUsdt: '0',
    memo: '1',
    waitStartDt: '',
    waitExpireDt: '',
    startDt: '',
    endDt: '',
    factoryId: '',
    isHide: 0,
    privateTokenSymbol: null,
    extraContractAddr: null,
  });
  const [oldPools, setOldPools] = useState(pools);

  const navigate = useNavigate();

  useEffect(() => {
    rowValue.endDt = rowValue.endDt.split(' ')[0];
    rowValue.startDt = rowValue.startDt.split(' ')[0];
    rowValue.waitStartDt = rowValue.waitStartDt.split(' ')[0];
    rowValue.waitExpireDt = rowValue.waitExpireDt.split(' ')[0];
    console.log(rowValue);
    setPools(rowValue);
    setOldPools(rowValue);

    return () => {};
  }, []);

  const onSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsLoading(true);
    // 풀이름 추가, 설명 추가, 최소스테이킹 금액(달러), 이자율, 모금 기간, 운영기간, 최소최대 함수 호출
    await handleContract();
  };

  const handleContract = async () => {
    setIsLoading(false);
    // updatePool;

    const data = compareObjects(pools, oldPools);
    console.log(data);
    const re = await updatePool(rowValue.poolId, data);
    console.log(re);
    if (re.status !== 200) {
      return;
    }
    toast.success('성공');
    navigate('/pool-list');
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
        }}
      >
        <PoolSettingForm pools={pools} setPools={setPools} title="Pool-Detail" type="detail" />
        <Button variant="contained" onClick={onSubmit}>
          Update
        </Button>
      </Box>
      <Loading isLoading={isLoading} />
    </>
  );
}
